import React from "react";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/src/components/ui/pagination";

interface DiecutPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

function pageRange(page: number, totalPages: number): (number | "…")[] {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
  if (page <= 4) return [1, 2, 3, 4, 5, "…", totalPages];
  if (page >= totalPages - 3)
    return [1, "…", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  return [1, "…", page - 1, page, page + 1, "…", totalPages];
}

const linkClass =
  "rounded-[16px] backdrop-blur-xl bg-white/20 dark:bg-black/20 border border-white/30 dark:border-white/10 text-walnut-800 dark:text-walnut-200 hover:bg-white/30 dark:hover:bg-white/10 transition-all";

const activeClass =
  "rounded-[16px] bg-walnut-500/20 border border-walnut-500/30 text-walnut-700 dark:text-walnut-300";

export const DiecutPagination: React.FC<DiecutPaginationProps> = ({
  page,
  totalPages,
  onPageChange,
}) => {
  const ranges = pageRange(page, totalPages);

  return (
    <Pagination className="mt-10">
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (page > 1) onPageChange(page - 1);
            }}
            className={`${linkClass} ${page === 1 ? "pointer-events-none opacity-40" : ""}`}
          />
        </PaginationItem>

        {ranges.map((r, i) =>
          r === "…" ? (
            <PaginationItem key={`ellipsis-${i}`}>
              <PaginationEllipsis className="text-walnut-600 dark:text-walnut-400" />
            </PaginationItem>
          ) : (
            <PaginationItem key={r}>
              <PaginationLink
                href="#"
                isActive={r === page}
                onClick={(e) => {
                  e.preventDefault();
                  onPageChange(r as number);
                }}
                className={r === page ? activeClass : linkClass}
              >
                {r}
              </PaginationLink>
            </PaginationItem>
          ),
        )}

        <PaginationItem>
          <PaginationNext
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (page < totalPages) onPageChange(page + 1);
            }}
            className={`${linkClass} ${page === totalPages ? "pointer-events-none opacity-40" : ""}`}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};
